document.addEventListener('DOMContentLoaded', () => {
  const sendCheckbox = document.getElementById('gift-card-send-checkbox');
  const fieldsContainer = document.getElementById('gift-card-fields');
  const nameInput = document.getElementById('gift-card-recipient-name');
  const emailInput = document.getElementById('gift-card-recipient-email');
  const messageInput = document.getElementById('gift-card-recipient-message');
  const dateInput = document.getElementById('gift-card-send-date');
  const charCount = document.getElementById('gift-card-char-count');
  
  // Get today's date in yyyy-mm-dd format
  const dateToday = new Date().toISOString().split('T')[0];
  // Set min attribute so it will not take past dates
  dateInput.setAttribute('min', dateToday);
  
  // On click of complete Date field, date field should open
  dateInput.addEventListener('click', function(e) {
    this.showPicker && this.showPicker();
  });

  // Prevent typing inside the date field
  dateInput.addEventListener('keydown', function(e) {
    e.preventDefault();
  });
  
  // Function to toggle field activation
  const toggleFields = (activate) => {
    nameInput.disabled = !activate;
    emailInput.disabled = !activate;
    messageInput.disabled = !activate;
    dateInput.disabled = !activate;
  };
  
  // Initial state
  toggleFields(false);
  
  // Toggle hidden fields and activation
  sendCheckbox.addEventListener('change', () => {
    const isChecked = sendCheckbox.checked;
    fieldsContainer.classList.toggle('gift-card-hidden', !isChecked);
    toggleFields(isChecked);
    validateFields(isChecked);
  });

  // Adding Attribute for Validation
  const validateFields = (status) => {
    if (status === true) {
      nameInput.setAttribute('data-required', 'true');
      emailInput.setAttribute('data-required', 'true');
    } else {
      nameInput.removeAttribute('data-required', 'true');
      emailInput.removeAttribute('data-required', 'true');
      nameInput.value = '';
      emailInput.value = '';
      dateInput.value = '';
      messageInput.value = '';
      $('.gift-card-error').hide();
    }
  };
  
  // Real-time character countdown for message
  messageInput.addEventListener('input', function () {
    const remaining = 200 - this.value.length;
    charCount.innerText = `${remaining} characters remaining`;
  });
});